
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFogColour as ObiFogColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fog-colour.js';
 
 
 

 
 export const ObiFogColour = createComponent({
   react: React,
   tagName: 'obi-fog-colour',
   elementClass: ObiFogColourElement,
   events: {
     
   }
  });
 
 